// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "context_chat-" + chunkId + ".js?v=" + "1753e68e3908744ce3eb" + "";
};